export default "__VITE_ASSET__e8811678__"